// extracted by mini-css-extract-plugin
module.exports = {"tagOverlay":"TrainingImagesTagViewer_tagOverlay___YoCI","trash":"TrainingImagesTagViewer_trash__g_Cyt"};